import { h } from 'vue'

import { GoogleMeetIcon, ZoomIcon } from '@gohighlevel/ghl-icons/24/misc'
import { MarkerPin01Icon, VideoRecorderIcon } from '@gohighlevel/ghl-icons/24/outline'

import { currency } from '@common/core-layer/utils/currency'

import { EventVisibilityType, RepeatIntervalOptions } from './types/events'
import { EventColor } from './types/events'
import { CalendarViewTypes } from './types/events'

// Older colors, from old app.
// Need to keep these for backward compatibility, older events.s
export const OldEventColorMap = {
  '#FF5C00': EventColor.ORANGE,
  '#FF0000': EventColor.RED,
  '#0000FF': EventColor.BLUE,
  '#86CB3C': EventColor.GREEN,
  '#9400D3': EventColor.PURPLE,
  '#4B0082': EventColor.INDIGO,
  '#FFE500': EventColor.YELLOW,
}

export const EventBgColorMap = {
  [EventColor.ORANGE]: '#FFF1E6',
  [EventColor.RED]: '#FCE7F3',
  [EventColor.BLUE]: '#EAF2FF',
  [EventColor.GREEN]: '#E9FBEF',
  [EventColor.PURPLE]: '#F5EDFF',
  [EventColor.INDIGO]: '#EEF0FF',
  [EventColor.YELLOW]: '#E6F7FB',
}

export const EventColorOptions = Object.values(EventColor)

export const repeatIntervalOptions = [
  { label: 'events.options.repeatInterval.day', value: RepeatIntervalOptions.DAY },
  { label: 'events.options.repeatInterval.week', value: RepeatIntervalOptions.WEEK },
  { label: 'events.options.repeatInterval.month', value: RepeatIntervalOptions.MONTH },
  { label: 'events.options.repeatInterval.year', value: RepeatIntervalOptions.YEAR },
]

export const dayOfWeekOptions = [
  { label: 'events.options.dayOfWeek.monday', value: 'monday' },
  { label: 'events.options.dayOfWeek.tuesday', value: 'tuesday' },
  { label: 'events.options.dayOfWeek.wednesday', value: 'wednesday' },
  { label: 'events.options.dayOfWeek.thursday', value: 'thursday' },
  { label: 'events.options.dayOfWeek.friday', value: 'friday' },
  { label: 'events.options.dayOfWeek.saturday', value: 'saturday' },
  { label: 'events.options.dayOfWeek.sunday', value: 'sunday' },
]

export const billingPeriodOptions = [
  { label: 'events.options.billingPeriod.monthly', value: 'monthly' },
  { label: 'events.options.billingPeriod.quarterly', value: 'quarterly' },
  { label: 'events.options.billingPeriod.yearly', value: 'yearly' },
]

export const priceTypes = [
  { label: 'events.options.priceType.free', value: 'Free', icon: 'tag' },
  { label: 'events.options.priceType.paid', value: 'Paid', icon: 'dollar' },
]

export const CalendarViewOptions = [
  { label: 'events.options.calendarView.month', value: CalendarViewTypes.MONTH },
  { label: 'events.options.calendarView.week', value: CalendarViewTypes.WEEK },
]

export const levelOptions = Array.from({ length: 9 }, (_, i) => {
  const level = String(i + 1)
  return { label: level, value: level }
})

export const attendeeOptions = [
  { label: 'events.options.attendee.allMembers', value: EventVisibilityType.ALL },
  { label: 'events.options.attendee.membersAtLevel', value: EventVisibilityType.LEVEL },
  { label: 'events.options.attendee.membersOfCourse', value: EventVisibilityType.COURSE },
  { label: 'events.options.attendee.memberOfChannel', value: EventVisibilityType.CHANNEL },
]

export enum EventLocation {
  LIVE_ROOM = 'golive',
  ZOOM = 'zoom',
  MEET = 'meet',
  OTHER = 'other',
}

export const locationOptions = [
  {
    label: 'events.options.location.liveRoom',
    value: EventLocation.LIVE_ROOM,
    tagRenderer: () => h('div', { class: 'flex items-center gap-2' }, [h(VideoRecorderIcon, { class: 'w-4 h-4' }), h('span', 'Live Room')]),
  },
  {
    label: 'Zoom',
    value: EventLocation.ZOOM,
    tagRenderer: () => h('div', { class: 'flex items-center gap-2' }, [h(ZoomIcon, { class: 'w-4 h-4' }), h('span', 'Zoom')]),
  },
  {
    label: 'Meet',
    value: EventLocation.MEET,
    tagRenderer: () => h('div', { class: 'flex items-center gap-2' }, [h(GoogleMeetIcon, { class: 'w-4 h-4' }), h('span', 'Meet')]),
  },
  {
    label: 'events.options.location.other',
    value: EventLocation.OTHER,
    tagRenderer: () => h('div', { class: 'flex items-center gap-2' }, [h(MarkerPin01Icon, { class: 'w-4 h-4' }), h('span', 'Other')]),
  },
]

export const DEFAULT_EVENT_DURATION_MINUTES = 30

export const amPmOptions = [
  { label: 'AM', value: 'AM' },
  { label: 'PM', value: 'PM' },
]

export const currencyOptions = Object.keys(currency).map(code => ({
  label: code,
  value: code,
}))
